import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

import { ComponentOptionsContentSection } from './contentTypes';

export interface ComponentWrapperProps extends ComponentOptionsContentSection {
  children?: React.ReactNode;
  classNames?: string;
}

export const ComponentWrapper = ({ children, classNames, options }: ComponentWrapperProps) => {
  const sectionId = options?.id;
  const sectionClass = options?.class;

  const containerCondition = options?.container?.enabled ?? false;
  const containerSize = options?.container?.size as b2x.Breakpoint | 'always';

  const marginTop = options?.margin?.top && spaceMatrix({ breakpoint: options.margin.top, spacerType: 'mt' });
  const marginBottom = options?.margin?.bottom && spaceMatrix({ breakpoint: options.margin.bottom, spacerType: 'mb' });
  const margin = `${marginTop} ${marginBottom}`;

  const paddingTop = options?.padding?.top && spaceMatrix({ breakpoint: options.padding.top, spacerType: 'pt' });
  const paddingBottom =
    options?.padding?.bottom && spaceMatrix({ breakpoint: options.padding.bottom, spacerType: 'pb' });
  const padding = `${paddingTop} ${paddingBottom}`;

  return options?.enabled ? (
    <section className={classnames(classNames, margin, padding, sectionClass)} id={sectionId}>
      <b2x.ConditionalWrapper condition={containerCondition} wrapper={<b2x.Container fluid={containerSize} />}>
        {children}
      </b2x.ConditionalWrapper>
    </section>
  ) : (
    <></>
  );
};

interface SpaceMatrixProps {
  breakpoint: {
    lg?: string | undefined;
    md?: string | undefined;
    sm?: string | undefined;
    xl?: string | undefined;
    xs?: string | undefined;
    xxl?: string | undefined;
  };
  spacerType: 'pb' | 'pt' | 'mb' | 'mt';
}

const spaceMatrix = ({ breakpoint, spacerType }: SpaceMatrixProps) => {
  let spacers = '';

  spacers = `${spacerType}-${breakpoint.xs}`;
  spacers = breakpoint.xs === breakpoint.sm ? spacers : `${spacers} ${spacerType}-sm-${breakpoint.sm}`;
  spacers = breakpoint.sm === breakpoint.md ? spacers : `${spacers} ${spacerType}-md-${breakpoint.md}`;
  spacers = breakpoint.md === breakpoint.lg ? spacers : `${spacers} ${spacerType}-lg-${breakpoint.lg}`;
  spacers = breakpoint.lg === breakpoint.xl ? spacers : `${spacers} ${spacerType}-xl-${breakpoint.xl}`;
  spacers = breakpoint.xl === breakpoint.xxl ? spacers : `${spacers} ${spacerType}-xl-${breakpoint.xxl}`;

  return spacers;
};
